import React from 'react'

import { TableComponents, Skeleton } from '@sketch/components'

import { IntegrationInfo, ActionCell } from './WorkspaceIntegrations.styles'

export const SkeletonRow: React.FC = () => (
  <TableComponents.TableRow>
    <TableComponents.TableCell>
      <IntegrationInfo>
        <Skeleton height="32px" width="32px" />
        <Skeleton height="16px" width="100px" />
      </IntegrationInfo>
    </TableComponents.TableCell>
    <TableComponents.TableCell>
      <ActionCell>
        <Skeleton height="32px" width="80px" />
      </ActionCell>
    </TableComponents.TableCell>
  </TableComponents.TableRow>
)
